import styled from 'styled-components';

import { Carousel } from '@xing-com/carousel';
import { JobTeaserCardSkeleton } from '@xing-com/crate-jobs-xinglets';
import { GridContainer, GridItem } from '@xing-com/grid';
import { SkeletonHeadline } from '@xing-com/skeleton';
import { spaceXXL } from '@xing-com/tokens';

const BodyHeadline = styled(SkeletonHeadline)`
  height: 30px;
  margin-bottom: ${spaceXXL};
`;

type JobRecommendationsSkeletonProps = { type: 'carousel' | 'grid' };

export const RecommendationsSkeleton: React.FC<
  JobRecommendationsSkeletonProps
> = ({ type }) => {
  return type === 'carousel' ? (
    <>
      <BodyHeadline amountRows={1} />
      <Carousel hideScrollbar itemWidth={'60%'}>
        <JobTeaserCardSkeleton />
        <JobTeaserCardSkeleton />
        <JobTeaserCardSkeleton />
      </Carousel>
    </>
  ) : (
    <>
      <GridContainer variant="two-col">
        <BodyHeadline amountRows={1} />
      </GridContainer>
      <GridContainer variant="FullSize">
        <GridItem spanLarge={4} spanMedium={4}>
          <JobTeaserCardSkeleton />
        </GridItem>
        <GridItem spanLarge={4} spanMedium={4}>
          <JobTeaserCardSkeleton />
        </GridItem>
        <GridItem spanLarge={4} spanMedium={4}>
          <JobTeaserCardSkeleton />
        </GridItem>
      </GridContainer>
    </>
  );
};
